<div class="auth-wrapper">
  <div class="auth-shade d-flex align-items-center justify-content-center">
    <div class="login-content p-4">
      <mat-card class="login-card" appearance="outlined">
        <mat-card-header class="login-header">
             <div class="logo-section mb-2">
            <img src="../../../assets/images/logo.svg">
          </div>
        </mat-card-header>

        <mat-card-content class="login-form-container">
          <form class="login-form">
            <h2 class="auth-title fs-24 fw-medium my-0">Access locked!</h2>
            <p class="auth-description mt-2 mb-0 fs-14">Your account has been temporarily locked to protect your security.
             <br>   For assistance with your password, please contact your supervisor.</p>
            
            <div class="auth-form fs-14 mt-4">
              

              <div class="form-actions">
                <button type="submit" class="login-button auth-btn fs-14 fw-semibold">
                  <div class="button-content">
                    <span>Continue</span>
                  </div>
                </button>
                <a href="#" class="mt-3 mx-auto d-block text-center notify-text fs-14">Learn More</a>

              </div>
            </div>
          </form>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="d-flex justify-content-center mt-auto mb-0 navi-link">
      <a href="#" class="fs-12">Terms of Service</a>
      <a href="#" class="fs-12">Privacy Policy</a>
      <a href="#" class="fs-12">Cookie Policy</a>


    </div>
  </div>
</div>
